import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-ressetpwd',
  templateUrl: './ressetpwd.component.html',
  styleUrls: ['./ressetpwd.component.scss']
})
export class RessetpwdComponent implements OnInit, OnDestroy {

  private subs = new SubSink();
  public statusDetail: 'loading' | 'success' | 'error' | 'init' = 'init';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FormGroup,
    public router: Router,
    public dialog: MatDialog,
    private auth: AuthService,
  ) { };

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  };

  ngOnInit(): void {
    this.closeModal();
  };

  public closeModal(): void {
    this.resetPasswod(this.data);
  };

  public resetPasswod(form: FormGroup): void {
    this.subs.sink = this.auth.resetPassword(form)
      .subscribe(() => {
        this.statusDetail = 'success';
        setTimeout(() => {
          this.router.navigateByUrl('/auth/login');
          this.dialog.closeAll()
        }, 2000);
      }, error => {
        this.statusDetail = 'error';
        setTimeout(() => {
          this.dialog.closeAll()
        }, 2000);
      });
  };
}
